import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const OPTION = 'option'
export const GOAL = 'goal'
export const COUNT = 'count'
export const DIFF = 'diff'
export const NO_QUOTAS = 'no-quotas'

export default {
  [PORTUGUESE]: {
    [OPTION]: 'Opção',
    [GOAL]: 'Meta',
    [COUNT]: 'Contagem',
    [DIFF]: 'Diferença',
    [NO_QUOTAS]: 'Ainda não foram definidas cotas para esta pesquisa.',
  },

  [ENGLISH]: {
    [OPTION]: 'Option',
    [GOAL]: 'Goal',
    [COUNT]: 'Count',
    [DIFF]: 'Diff',
    [NO_QUOTAS]: 'No quotas were set for this survey yet.',
  },

  [SPANISH]: {
    [OPTION]: 'Opción',
    [GOAL]: 'Meta',
    [COUNT]: 'Puntaje',
    [DIFF]: 'Diferencia',
    [NO_QUOTAS]: 'Aún no se establecieron cuotas para esta encuesta.',
  },
}
